import React from 'react';
import { i18n } from 'config/locales';
import ValidationElement from 'components/Form/ValidationElement';
import { ValidationElementProps } from 'components/Form/ValidationElement/ValidationElement';
import { CommonOnUpdate, CommonOnError, CommonRequired } from 'types/props';
import { SubstanceAlcoholOrderedByModel } from 'forms/sections/substance/alcohol/counseling/mandatory/types';
import Textarea from 'components/Form/Textarea';
import { setAttribute } from 'components/Form/shared/setAttribute';
import { counselingOrderedByOptions } from 'constants/enums/substanceOptions';
import RadioGroup from 'components/Form/RadioGroup';
import Radio from 'components/Form/Radio';

interface Props
  extends Partial<SubstanceAlcoholOrderedByModel>,
  ValidationElementProps {
  onUpdate?: CommonOnUpdate
  onError?: CommonOnError
  required?: CommonRequired
  disabled?: boolean
  attribute?: string
  className?: string
  multiple?: boolean
}

export default class OrderedBy extends ValidationElement<Props> {
  constructor(props) {
    super(props);
  }

  update = (queue: Partial<SubstanceAlcoholOrderedByModel>) => {
    this.props.onUpdate({
      OrderedBy: this.props.OrderedBy,
      OrderedByExplanation: this.props.OrderedByExplanation,
      ...queue,
    });
  };

  updateOrderedBy = (value: SubstanceAlcoholOrderedByModel['OrderedBy']) => {
    this.update({
      OrderedBy: value,
      OrderedByExplanation: {},
    });
  };

  updateOrderedByExplanation = (value: SubstanceAlcoholOrderedByModel['OrderedByExplanation']) => {
    this.update({
      OrderedByExplanation: value,
    });
  };

  render() {
    return (
      <div className={this.props.className}>
        <RadioGroup
          className="ordered-by option-list option-list-vertical"
          required={this.props.required}
          onError={this.props.onError}
          selectedValue={(this.props.OrderedBy || {}).value}
          attribute={setAttribute(this.props.attribute, 'orderedby')}
        >
          {counselingOrderedByOptions.map((option) => (
            <Radio
              key={option}
              name={option}
              label={option}
              value={option}
              className={option}
              onUpdate={this.updateOrderedBy}
              onError={this.props.onError}
            />
          ))}
        </RadioGroup>

        {this.props.OrderedBy?.value === 'Other'
          && (
          <>
            {i18n.t('substance.pvq.alcohol.orderedCounseling.label.explain')}
            <Textarea
              {...this.props.OrderedByExplanation}
              name="OrderedByExplanation"
              className="substance-alcoholo-orderedby-explanation"
              onUpdate={this.updateOrderedByExplanation}
              onError={this.props.onError}
              required={this.props.required}
              disabled={this.props.disabled}
              attribute={`${this.props.attribute}.OrderedByExplanation`}
            />
          </>
          )}
      </div>
    );
  }
}

OrderedBy.defaultProps = {
  multiple: false,
  className: 'orderedby',
  OrderedBy: {},
  OrderedByExplanation: {},
  onUpdate: (queue) => { },
  onError: (value, arr: ErrorCode[]) => arr,
};

OrderedBy.errors = [];
